import { Modal, notification } from "antd";
import { common } from "utils/Wording";
import checkCircle from "assets/icons/notification/check-circle.svg";
import closeCircle from "assets/icons/notification/close-circle.svg";
import { NotificationPlacement } from "antd/lib/notification";
import { globalLogOut, isAuthPage } from "utils/Actions";
import { CloseCircleOutlined } from "@ant-design/icons";

type notificationType = {
  message: string;
  description?: string;
  placement?: NotificationPlacement;
  checkInApp?: boolean;
};

export const showSuccessNotification = ({
  message,
  description,
  placement,
  checkInApp
}: notificationType): void => {
  if (checkInApp) {
    if (isAuthPage()) {
      return;
    }
  }
  return notification["success"]({
    message,
    description,
    style: {
      width: 300
    },
    icon: <img src={checkCircle} alt="" />,
    placement: placement
  });
};

export const showErrorNotification = ({
  message,
  description,
  checkInApp
}: notificationType): void => {
  if (checkInApp) {
    if (isAuthPage()) {
      return;
    }
  }
  return notification["error"]({
    message,
    description,
    style: {
      width: 300
    },
    icon: <img src={closeCircle} alt="" />
  });
};

type errorModalType = {
  title: string;
  pTitle?: string;
  errors: string[];
};

export const showErrorModal = ({ title, pTitle, errors }: errorModalType): void => {
  Modal.error({
    title: <div autoFocus>{title}</div>,
    content: (
      <div>
        <p>{pTitle}</p>
        <ul style={{ paddingLeft: "2rem" }}>
          {errors && errors.length > 0 ? (
            errors.map((err, idx) => <li key={idx}>{err}</li>)
          ) : (
            <p>{common.failAsync}</p>
          )}
        </ul>
      </div>
    ),
    closable: true,
    okText: isAuthPage() ? "OK" : "Return to landing page",
    onOk: globalLogOut,
    icon: <CloseCircleOutlined style={{ color: "red" }} aria-label="Error icon" />,
    autoFocusButton: null
  });
};

type infoModalType = {
  title: string;
  info: string;
};

export const showInfoModal = ({ title, info }: infoModalType): void => {
  Modal.info({
    title,
    content: <p>{info}</p>
  });
};
